const MAX_HISTORY = 500

/**
 * Manages the state of an SQL textarea
 */
class SqlHistoryManager {
	constructor(initialValue = '') {
		this.history = [ initialValue ]
		this.historyIndex = 0
	}

	setSelectedRange(el) {
		this.selectedRange = { start: el.selectionStart, end: el.selectionEnd }
	}

	getSelectedRange() {
		return this.selectedRange || null
	}

	/**
	 * Move the history index up or down the history. -1 will move back (undo),
	 * +1 will move forward (redo)
	 * @param {number} direction
	 * @return {string} if there is any history left, returns the value of the next
	 * or previous history value; otherwise returns null
	 */
	shift(direction) {
		const nextHistoryIndex = this.historyIndex + direction
		if (nextHistoryIndex >= 0 && nextHistoryIndex < this.history.length) {
			this.historyIndex = nextHistoryIndex
			const lastHistoryItem = this.history[this.historyIndex]
			return lastHistoryItem
		}
		return null
	}

	add(value = '') {
		if (this.historyIndex !== this.history.length - 1) {
			// We have performed some "undos", so we are going to wipe any history
			// after this point before writing the new history item
			this.history.splice(this.historyIndex, this.history.length - this.historyIndex)
		}
		this.history.push(value)
		if (this.history.length > MAX_HISTORY) {
			// Trim the history so it doesn't get too big
			this.history.shift()
		}
		this.historyIndex = this.history.length - 1

	}

	reset(value = '') {
		this.history = [ value ]
		this.historyIndex = 0
	}
}

export default SqlHistoryManager
SqlHistoryManager.__filename__ = 'components/sql-console/sql-history-manager.js'
